// assets/yip-product-slider.js
// YIP lite: products-only, scroll-snap, arrows, mounts at <!-- SLIDER -->
(function () {
  'use strict';

  const CFG_SEL = '.yip-slider-config[data-article-id]';
  const TICK_HIDE_MS = 1600;

  const onReady = f => (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', f) : f());
  const waitDeps = cb => (typeof PUB_SUB_EVENTS !== 'undefined' && window.Shopify?.pubsub ? cb() : setTimeout(() => waitDeps(cb), 50));

  onReady(() => {
    document.querySelectorAll(CFG_SEL).forEach(async (cfgEl) => {
      let cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch { return; }
      const container = document.querySelector(`.yip-slider[data-article-id="${cfg.articleId}"]`);
      if (!container) return;

      placeAtMarker(container);

      const rail = container.querySelector(`#yip-slider-products-${cfg.articleId}`);
      const prev = container.querySelector('.yip-slider-prev');
      const next = container.querySelector('.yip-slider-next');

      const handles = Array.isArray(cfg.products) ? cfg.products.filter(Boolean) : [];
      const products = (await loadProducts(handles)).sort((a, b) => Number(b.available) - Number(a.available));

      rail.innerHTML = products.length ? products.map(cardHTML).join('') : `<div class="yip-empty-state">Gösterilecek ürün bulunamadı.</div>`;

      const stepSize = () => {
        const first = rail.querySelector('.yip-product-card'); if (!first) return rail.clientWidth * 0.9;
        const nextEl = first.nextElementSibling;
        return nextEl ? (nextEl.offsetLeft - first.offsetLeft) : (first.getBoundingClientRect().width + 12);
      };
      const updateArrows = () => {
        const max = Math.max(0, rail.scrollWidth - rail.clientWidth - 1);
        prev.setAttribute('aria-disabled', rail.scrollLeft <= 0 ? 'true' : 'false');
        next.setAttribute('aria-disabled', rail.scrollLeft >= max ? 'true' : 'false');
      };
      prev.addEventListener('click', () => { if (prev.getAttribute('aria-disabled') !== 'true') rail.scrollBy({ left: -stepSize() * 2, behavior: 'smooth' }); });
      next.addEventListener('click', () => { if (next.getAttribute('aria-disabled') !== 'true') rail.scrollBy({ left:  stepSize() * 2, behavior: 'smooth' }); });
      rail.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();

      rail.addEventListener('click', (e) => {
        const btn = e.target.closest('.yip-product-card__add');
        if (!btn || !rail.contains(btn) || btn.classList.contains('is-checked') || btn.disabled) return;
        e.preventDefault();
        addToCart(btn);
      });

      waitDeps(() => {
        if (window.__YIP_CART_WIRED__) return;
        window.__YIP_CART_WIRED__ = true;

        fetch('/cart.js').then(r => r.json()).then(syncCartUI).catch(() => {});
        Shopify.pubsub.subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => {
          const cart = ev?.cartData;
          if (cart?.items) syncCartUI(cart);
          else fetch('/cart.js').then(r => r.json()).then(syncCartUI).catch(() => {});
        });
      });
    });
  });

  // ---------- Cart add + cap ----------
  function addToCart(btn) {
    const card = btn.closest('[data-product-id]');
    const vid = card?.getAttribute('data-product-id');
    if (!vid) return;
    if (card.classList.contains('yip-out-of-stock')) return;

    clearCapped(btn);
    btn.classList.add('is-checked');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    })
      .then(async r => {
        const data = await r.json().catch(() => ({}));
        if (!r.ok || data?.status >= 400) { const e = new Error(data?.description || 'Cart add failed'); e.status = r.status; throw e; }
        return fetch('/cart.js').then(x => x.json());
      })
      .then(cart => {
        try { Shopify.pubsub.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'yip-product-card', cartData: cart }); } catch {}
        checkAndCapFromCart(btn, cart);
        scheduleTickHide(btn);
      })
      .catch(async err => {
        if (err?.status === 422 || /maksimum|maximum/i.test(String(err?.message || ''))) setCapped(btn, true);
        try {
          const cart = await fetch('/cart.js').then(x => x.json());
          try { Shopify.pubsub.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'yip-product-card-error', cartData: cart }); } catch {}
          checkAndCapFromCart(btn, cart);
        } catch {}
        btn.classList.remove('is-checked');
      });
  }

  function setCapped(btn, hard = false) {
    if (!btn.dataset.origHtml) btn.dataset.origHtml = btn.innerHTML;
    btn.dataset.capHard = hard ? '1' : '';
    btn.classList.remove('is-checked');
    btn.classList.add('is-capped');
    btn.setAttribute('disabled', 'disabled');
    btn.textContent = '--';
    if (btn.__yipTickTmr) { clearTimeout(btn.__yipTickTmr); btn.__yipTickTmr = null; }
  }
  function clearCapped(btn) {
    delete btn.dataset.capHard;
    if (btn.classList.contains('is-capped') && btn.dataset.origHtml) btn.innerHTML = btn.dataset.origHtml;
    btn.classList.remove('is-capped');
    btn.removeAttribute('disabled');
  }
  function checkAndCapFromCart(btn, cart) {
    const card = btn.closest('[data-product-id]'); if (!card) return;
    const variantId = String(card.getAttribute('data-product-id') || '');
    const invAttr = card.getAttribute('data-inventory-quantity');
    const inv = invAttr === '' ? NaN : parseInt(invAttr, 10);
    const isOOS = card.classList.contains('yip-out-of-stock');
    const it = cart?.items?.find(x => String(x.variant_id) === variantId);
    const qty = it ? it.quantity : 0;

    if (btn.dataset.capHard === '1') { if (qty > 0) { setCapped(btn, true); return; } clearCapped(btn); return; }

    const capped = (isOOS && qty > 0) || (Number.isFinite(inv) && inv > 0 && qty >= inv);
    if (capped) setCapped(btn); else if (!isOOS) clearCapped(btn);
  }
  function scheduleTickHide(btn) {
    if (btn.__yipTickTmr) clearTimeout(btn.__yipTickTmr);
    btn.__yipTickTmr = setTimeout(() => { if (!btn.classList.contains('is-capped')) btn.classList.remove('is-checked'); btn.__yipTickTmr = null; }, TICK_HIDE_MS);
  }
  function syncCartUI(cart) {
    document.querySelectorAll('.yip-product-card__add').forEach(btn => checkAndCapFromCart(btn, cart));
  }

  // ---------- Placement / data ----------
  function placeAtMarker(container) {
    const host = document.querySelector('#yip-article-content') || document.querySelector('.article-template__content') || document;
    const walker = document.createTreeWalker(host, NodeFilter.SHOW_COMMENT);
    let n; while ((n = walker.nextNode())) { if ((n.textContent || '').trim().toUpperCase() === 'SLIDER') { n.parentNode.insertBefore(container, n); n.remove(); break; } }
  }

  async function loadProducts(handles) {
    const jobs = handles.map(async (h) => {
      try { const r = await fetch(`/products/${encodeURIComponent(h)}.js`); if (!r.ok) return null; return normalize(await r.json()); }
      catch { return null; }
    });
    const arr = (await Promise.all(jobs)).filter(Boolean);
    const m = new Map(); arr.forEach(p => { const k = p.id || p.handle; if (!m.has(k)) m.set(k, p); });
    return [...m.values()];
  }

  function toCents(v) {
    if (v == null) return null;
    if (typeof v === 'number') return (Number.isInteger(v) && v >= 1000) ? v : Math.round(v * 100);
    const s = String(v).trim();
    if (/^\d+$/.test(s)) { const n = parseInt(s, 10); return n >= 1000 ? n : n * 100; }
    const n = parseFloat(s.replace(/\s+/g, '').replace(/\./g, '').replace(',', '.'));
    return Number.isFinite(n) ? Math.round(n * 100) : null;
  }
  function normalize(p) {
    const imgs = Array.isArray(p.images) ? p.images : [];
    const firstImg = imgs.length ? (typeof imgs[0] === 'string' ? imgs[0] : (imgs[0]?.src || null)) : null;
    const variants = Array.isArray(p.variants) ? p.variants.map(v => {
      const inv = typeof v.inventory_quantity === 'number' ? v.inventory_quantity : null;
      const available = (v.available === true) && (inv === null || inv > 0);
      return { id: v.id, available, inventory_quantity: inv, price_cents: toCents(v.price), compare_at_cents: toCents(v.compare_at_price) };
    }) : [];
    const available = variants.some(v => v.available === true);
    return { id: p.id, handle: p.handle, title: p.title, url: `/products/${p.handle}`, image: firstImg, variants, available };
  }
  function cardHTML(p) {
    const v = p.variants.find(x => x.available) || p.variants[0] || {};
    const vid = v?.id ? String(v.id) : '';
    const price = typeof v.price_cents === 'number' ? v.price_cents : null;
    const cmp = typeof v.compare_at_cents === 'number' ? v.compare_at_cents : null;
    const disc = price != null && cmp != null && cmp > price ? Math.round(((cmp - price) / cmp) * 100) : null;
    const isAvail = !!vid && !!(p.available && v.available);
    const img = p.image || '//cdn.shopify.com/s/images/admin/no-image-large.gif';
    const t = escapeHtml(p.title || '');
    return `
<article class="yip-product-card${isAvail ? '' : ' yip-out-of-stock'}" data-product-id="${vid}" data-inventory-quantity="${v.inventory_quantity ?? ''}">
  ${!isAvail ? `<div class="yip-out-of-stock-badge">Tükendi</div>` : ''}
  <header class="yip-product-card-header">
    <a href="${p.url}" class="yip-product-card-header__link" aria-label="${t}">
      <div class="yip-product-card__img"><img src="${img}" width="173" height="172" alt="${t}" loading="lazy"></div>
      <h3 class="yip-product-card__title">${t}</h3>
    </a>
  </header>
  <footer class="yip-product-card__footer">
    <div class="yip-product-card__info">
      ${disc != null
        ? `<p class="yip-product-card__price" style="color:#44b183;">${fmt(price)}</p>
           <p class="yip-product-card__discounted-price">${fmt(cmp)}</p>
           <p class="yip-product-card__discount-amount">-%${disc}</p>`
        : `<p class="yip-product-card__price">${price != null ? fmt(price) : ''}</p>`}
    </div>
    <button class="yip-product-card__add yip-add-to-cart-btn" data-variant-id="${vid}" ${isAvail ? '' : 'disabled'} type="button" aria-label="Sepete ekle">
      <span class="icon-plus"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></span>
      <span class="icon-check"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12l5 5L20 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
    </button>
  </footer>
</article>`;
  }
  function fmt(c) { return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format((c || 0) / 100); }
  function escapeHtml(t) { const d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
})();
